import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLocalization } from '../context/LocalizationContext';
import { authAPI } from '../services/api';
import styles from '../styles/Auth.module.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t, currentLanguage, setCurrentLanguage, languages } = useLocalization();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login({ email, password });
      login(response.data.user, response.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || t('auth_login_failed', 'Login failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <div className={styles.languageRow}>
          <label htmlFor="language-select">{t('common_language', 'Language')}</label>
          <select
            id="language-select"
            className={styles.languageSelect}
            value={currentLanguage}
            onChange={(e) => setCurrentLanguage(e.target.value)}
          >
            {languages.filter((language) => language.isActive).map((language) => (
              <option key={language.code} value={language.code}>{language.name}</option>
            ))}
          </select>
        </div>

        <h1 className={styles.title}>{t('app_name', 'Daily Tracker')}</h1>
        <p className={styles.subtitle}>{t('auth_login_subtitle', 'Login to your account')}</p>

        {error && <div className={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="email">{t('auth_email', 'Email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder={t('auth_email', 'Email')}
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password">{t('auth_password', 'Password')}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          <button type="submit" disabled={loading} className={styles.submitBtn}>
            {loading ? t('auth_logging_in', 'Logging in...') : t('auth_login', 'Login')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
